import { MonthlyPrayerTimes } from '../types';

export const junePrayerTimes: MonthlyPrayerTimes = {
  1: {
    fajr: "02:27",
    shoruk: "03:36",
    dhuhr: "12:51",
    asr: "17:25",
    maghrib: "21:55",
    isha: "22:56"
  },
  2: {
    fajr: "02:27",
    shoruk: "03:35",
    dhuhr: "12:51",
    asr: "17:26",
    maghrib: "21:57",
    isha: "22:58"
  },
  3: {
    fajr: "02:26",
    shoruk: "03:34",
    dhuhr: "12:51",
    asr: "17:26",
    maghrib: "21:58",
    isha: "22:59"
  },
  4: {
    fajr: "02:25",
    shoruk: "03:33",
    dhuhr: "12:51",
    asr: "17:27",
    maghrib: "22:00",
    isha: "23:00"
  },
  5: {
    fajr: "02:25",
    shoruk: "03:31",
    dhuhr: "12:51",
    asr: "17:27",
    maghrib: "22:01",
    isha: "23:01"
  },
  6: {
    fajr: "02:24",
    shoruk: "03:30",
    dhuhr: "12:52",
    asr: "17:28",
    maghrib: "22:03",
    isha: "23:02"
  },
  7: {
    fajr: "02:23",
    shoruk: "03:29",
    dhuhr: "12:52",
    asr: "17:28",
    maghrib: "22:04",
    isha: "23:03"
  },
  8: {
    fajr: "02:23",
    shoruk: "03:28",
    dhuhr: "12:52",
    asr: "17:29",
    maghrib: "22:05",
    isha: "23:04"
  },
  9: {
    fajr: "02:23",
    shoruk: "03:28",
    dhuhr: "12:52",
    asr: "17:30",
    maghrib: "22:07",
    isha: "23:04"
  },
  10: {
    fajr: "02:22",
    shoruk: "03:27",
    dhuhr: "12:52",
    asr: "17:30",
    maghrib: "22:08",
    isha: "23:05"
  },
  11: {
    fajr: "02:22",
    shoruk: "03:26",
    dhuhr: "12:52",
    asr: "17:30",
    maghrib: "22:09",
    isha: "23:06"
  },
  12: {
    fajr: "02:22",
    shoruk: "03:26",
    dhuhr: "12:53",
    asr: "17:31",
    maghrib: "22:10",
    isha: "23:07"
  },
  13: {
    fajr: "02:21",
    shoruk: "03:25",
    dhuhr: "12:53",
    asr: "17:31",
    maghrib: "22:11",
    isha: "23:07"
  },
  14: {
    fajr: "02:21",
    shoruk: "03:25",
    dhuhr: "12:53",
    asr: "17:32",
    maghrib: "22:12",
    isha: "23:08"
  },
  15: {
    fajr: "02:21",
    shoruk: "03:24",
    dhuhr: "12:53",
    asr: "17:32",
    maghrib: "22:12",
    isha: "23:09"
  },
  16: {
    fajr: "02:21",
    shoruk: "03:24",
    dhuhr: "12:54",
    asr: "17:32",
    maghrib: "22:13",
    isha: "23:09"
  },
  17: {
    fajr: "02:21",
    shoruk: "03:24",
    dhuhr: "12:54",
    asr: "17:33",
    maghrib: "22:14",
    isha: "23:09"
  },
  18: {
    fajr: "02:21",
    shoruk: "03:24",
    dhuhr: "12:54",
    asr: "17:33",
    maghrib: "22:14",
    isha: "23:10"
  },
  19: {
    fajr: "02:21",
    shoruk: "03:24",
    dhuhr: "12:54",
    asr: "17:33",
    maghrib: "22:15",
    isha: "23:10"
  },
  20: {
    fajr: "02:22",
    shoruk: "03:24",
    dhuhr: "12:54",
    asr: "17:34",
    maghrib: "22:15",
    isha: "23:11"
  },
  21: {
    fajr: "02:22",
    shoruk: "03:25",
    dhuhr: "12:55",
    asr: "17:34",
    maghrib: "22:15",
    isha: "23:11"
  },
  22: {
    fajr: "02:22",
    shoruk: "03:25",
    dhuhr: "12:55",
    asr: "17:34",
    maghrib: "22:15",
    isha: "23:11"
  },
  23: {
    fajr: "02:22",
    shoruk: "03:25",
    dhuhr: "12:55",
    asr: "17:34",
    maghrib: "22:16",
    isha: "23:11"
  },
  24: {
    fajr: "02:23",
    shoruk: "03:25",
    dhuhr: "12:55",
    asr: "17:34",
    maghrib: "22:16",
    isha: "23:11"
  },
  25: {
    fajr: "02:23",
    shoruk: "03:26",
    dhuhr: "12:55",
    asr: "17:35",
    maghrib: "22:15",
    isha: "23:11"
  },
  26: {
    fajr: "02:23",
    shoruk: "03:26",
    dhuhr: "12:56",
    asr: "17:35",
    maghrib: "22:15",
    isha: "23:11"
  },
  27: {
    fajr: "02:24",
    shoruk: "03:27",
    dhuhr: "12:56",
    asr: "17:35",
    maghrib: "22:15",
    isha: "23:11"
  },
  28: {
    fajr: "02:24",
    shoruk: "03:28",
    dhuhr: "12:56",
    asr: "17:35",
    maghrib: "22:15",
    isha: "23:11"
  },
  29: {
    fajr: "02:25",
    shoruk: "03:28",
    dhuhr: "12:56",
    asr: "17:35",
    maghrib: "22:14",
    isha: "23:11"
  },
  30: {
    fajr: "02:25",
    shoruk: "03:29",
    dhuhr: "12:57",
    asr: "17:35",
    maghrib: "22:14",
    isha: "23:11"
  }
};